module.exports = __webpack_public_path__ + "static/media/om.2f5bcda5.svg";